import React from 'react';
import { Link } from 'react-router-dom';
import './Articles.css';

function Articles() {
  // Array of article objects with titles, descriptions, and links
  const articles = [
    /*{
      id: 1,
      title: 'AI Alignmnet via ML Interpretability',
      description: 'Various methods to use Interpretability for alignment',
      link: '/articles/alignment-from-interp'
    },
    {
      id: 2,
      title: 'Interpretability Race Conditions',
      description: 'Could our greatest hope be our undoing?',
      link: '/articles/interpretability-race-conditions'
    },
    {
      id: 3,
      title: 'My Thoughts on the Future of Interpretability',
      description: 'My framework of interpretability research and thoughts on where the field should head',
      link: '/articles/improving-interpretability-research'
    },
    {
      id: 4,
      title: 'Why AGI Development is a Suicidal Endeavor',
      description: 'A low jargon summary of the arguments that convinced me',
      link: '/articles/why-doom'
    },*/
    {
      id: 5,
      title: 'Probe Classification Expansion',
      description: 'Investigating the effects of expanding probe classification tasks on performance and representation',
      link: '/articles/probe-experiment-1'
    }
  ];

  return (
    <div className="articles-container">
      <h1 className="articles-title">Articles</h1>
      <p className="articles-intro">Welcome to my collection of wandering thoughts and ideas. Some pages will be rough drafts; I intend to update them piecemeal and in parallel.</p>
      <div className="article-grid">
        {articles.map(article => (
          <div key={article.id} className="article-card">
            <h2 className="article-title">
              <Link to={article.link}>{article.title}</Link>
            </h2>
            <p className="article-description">{article.description}</p>
            <Link to={article.link} className="read-more">Read More</Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Articles;
